import { ArrowRight, Check } from "lucide-react";
import { goToWaitlist } from "@/lib/site";
import { Reveal } from "./Reveal";

const PLANS = [
  { key: "free", name: "Free", price: "AED 0", period: "", storage: "20 photos · 1 GB", features: ["Private family space", "Capture & AI organizing", "The Family Loop & Chrono AI"] },
  { key: "family-plus", name: "Family Plus", price: "AED 29", period: "/mo", storage: "50 GB", popular: true, features: ["Everything in Free", "Unlimited photos, video & voice", "Everyone keeps adding"] },
  { key: "chrono-heritage", name: "Chrono Heritage", price: "AED 79", period: "/mo", storage: "250 GB", features: ["Everything in Plus", "4K video & multiple Stewards", "Priority AI", "2 free Capsules/yr"] },
];

const PlanCard = ({ plan, delay }) => (
  <Reveal
    delay={delay}
    data-testid={`pricing-card-${plan.key}`}
    className={`cl-card relative flex flex-col p-8 md:p-6 lg:p-10 ${
      plan.popular ? "border-[#E7C99D]/80 shadow-[0_0_70px_-18px_rgba(231,201,157,0.4),inset_0_0_40px_-20px_rgba(231,201,157,0.25)]" : "cl-card-hover"
    }`}
  >
    {plan.popular && (
      <span data-testid="pricing-most-popular-badge" className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gradient-to-r from-[#E7C99D] to-[#B8914F] px-4 py-1 text-[10px] font-semibold tracking-[0.24em] text-[#0A0C0F]">
        MOST POPULAR
      </span>
    )}
    <h3 className="text-xl font-light text-[#E6EDF4] lg:text-2xl">{plan.name}</h3>
    <p className="mt-6 flex items-baseline gap-1">
      <span data-testid={`pricing-price-${plan.key}`} className="cl-heading text-4xl text-[#E7C99D] lg:text-5xl">{plan.price}</span>
      {plan.period && <span className="text-sm text-[#9AAABD]">{plan.period}</span>}
    </p>
    <p className="mt-3 text-[11px] font-medium tracking-[0.2em] text-[#79B9FF]">{plan.storage.toUpperCase()}</p>
    <span className="my-8 h-px w-full bg-[#1C2A3A]" />
    <ul className="flex flex-1 flex-col gap-4">
      {plan.features.map((f) => (
        <li key={f} className="flex items-start gap-3 text-[14.5px] text-[#C9D3DE]">
          <Check size={15} strokeWidth={1.5} className="mt-0.5 shrink-0 text-[#E7C99D]" />
          {f}
        </li>
      ))}
    </ul>
    <a
      href="#launching-soon"
      onClick={goToWaitlist}
      data-testid={`pricing-get-started-${plan.key}`}
      className="btn-gold mt-10 w-full"
    >
      Get started <ArrowRight size={15} strokeWidth={1.4} />
    </a>
  </Reveal>
);

export const Pricing = () => (
  <section id="pricing" data-testid="section-pricing" className="cl-section relative">
    <div className="cl-container">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="cl-kicker">PRICING</p>
        <h2 className="cl-heading mt-5 text-4xl text-[#E6EDF4] sm:text-5xl">Simple plans that grow with you</h2>
      </Reveal>
      <div className="mt-16 grid gap-8 md:grid-cols-3 md:gap-4 lg:gap-6">
        {PLANS.map((p, i) => (
          <PlanCard key={p.key} plan={p} delay={i * 120} />
        ))}
      </div>
      <Reveal>
        <p data-testid="pricing-footnote" className="mx-auto mt-12 max-w-2xl text-center text-sm leading-relaxed text-[#9AAABD]">
          Chrono Capsules are a one-time purchase (AED 49–149 by lock length). Their storage is included.
        </p>
      </Reveal>
    </div>
  </section>
);
